export const ja = {
    translation: {
        b: {
            cancel: 'キャンセル',
            confirm: '確認',
            send: '送信',
            done: '完了',
            close: '閉じる',
            clear: 'クリア',
            copy_link: 'リンクをコピー',
            export: 'エクスポート',
            delete: '削除',
            delete_confirm: '削除の確認',
            duplicate: '複製',
            share: '共有',
            sign_in: 'サインイン',
            sign_up: 'サインアップ',
            email_address: 'メールアドレス',
            yes: 'はい',
            no: 'いいえ',
            back: '戻る',
            upgrade: 'アップグレード',
            remove: '削除',
            restore: '復元',
            archive: 'アーカイブ',
            rename: '名前を変更',
            leave: '退出',
            import: 'インポート',
            continue: '続ける',
            settings: '設定',
            log_out: 'ログアウト',
            invite: '招待',
            invited: '招待済み',
        },
        roles: {
            view: 'ビューアー',
            comment: 'コメンター',
            edit: '編集者',
            admin: '管理者',
            owner: 'オーナー',
            member: 'メンバー',
            remove: '削除',
            more_roles: 'その他のロール...',
            change_role: 'ロールを変更...',
            remove_access: 'アクセスを削除...',
            remove_invite: '招待を削除...',
        },
        db_engine: {
            basic: '基本 SQL',
            general: '汎用 SQL',
        },
        socket_status: {
            reconnecting: '再接続中...',
            offline: 'オフラインです。再接続中...',
        },
        loader: {
            diagram: 'ダイアグラムを読み込み中...',
        },
        m_languages: {
            title: '言語',
            subtitle: '言語を選択'
        },
        m_feedback: {
            feature: {
                name: '機能リクエスト',
                desc: '必要な機能が見つかりませんか？ぜひお知らせください — あなたのアイデアは重要です'
            },
            feedback: {
                name: 'フィードバックを共有',
                desc: '皆さまのご意見をぜひお聞かせください'
            },
            support: {
                name: 'サポート',
                desc: '何かうまく動作していませんか？お知らせください — 迅速に対応します',
            },
            bug: {
                name: '問題を報告',
                desc: '何かおかしいと感じましたか？報告してください — すぐに対応します',
            },
            integration: {
                name: '連携をリクエスト',
                desc: '皆さまのフィードバックは私たちにとって非常に大切です — ひと言だけでもお寄せください',
            },
        },
        m_feedback_t: {
            feature: {
                name: 'ご提案ありがとうございます！',
                desc: 'ご意見を共有するためにお時間をいただき感謝します — 製品改善の大きな助けになります。'
            },
            feedback: {
                name: 'フィードバックありがとうございます！',
                desc: 'ご意見を共有するためにお時間をいただき感謝します — 製品改善の大きな助けになります。'
            },
            support: {
                name: 'お問い合わせありがとうございます！',
                desc: 'サポートへのご連絡ありがとうございます — 内容を確認のうえ、できるだけ早くご返信いたします。',
            },
            bug: {
                name: 'ご報告ありがとうございます！',
                desc: 'ご報告いただきありがとうございます — 問題の迅速な解決とサービス改善に役立ちます。',
            },
            contact: {
                name: 'ご連絡ありがとうございます！',
                desc: 'メッセージを受け取りました。できるだけ早くご返信いたします。',
            },
            invite_people: {
                name: '招待を送信しました！',
                desc: '広めていただきありがとうございます — 新しいメンバーを歓迎できることを楽しみにしています。',
            },
            integration: {
                name: 'ご提案ありがとうございます！',
                desc: 'ご意見を共有するためにお時間をいただき感謝します — 製品改善の大きな助けになります。',
            },
        },
        m_diagram_details: {
            name_place: 'プロジェクト名を入力',
            desc_place: 'プロジェクトの説明を入力'
        },
        m_quick_share: {
            title: 'クイック共有',
            subtitle: '(クエリベースのリンク共有)'
        },
        m_export_img: {
            title: '画像をエクスポート'
        },
        search_menu: {
            placeholder: 'テーブル、列、型を検索...',
            hint: '',
            no_results: '結果が見つかりません',
            quick_results: 'クイック検索結果:',
            untitled: '無題',
            command_tag: 'コマンド',
            section_tables: 'テーブル',
            section_columns: '列',
            section_canvas: 'キャンバス',
            section_export: 'エクスポート',
            section_preferences: '環境設定',
            section_settings: '設定',
            type_table: 'テーブル',
            type_note: 'メモ',
            cmd_new_table: '新しいテーブルを作成...',
            cmd_new_note: '新しいメモを作成...',
            cmd_new_line: '新しいラインを作成...',
            cmd_new_area: '新しいエリアを作成...',
            cmd_export_image: '画像をエクスポート...',
            cmd_export_sql: 'SQL コードをエクスポート...',
            cmd_grid_style: 'グリッドレイアウトを変更...',
        },
        canvas_table: {
            more_column: '他の列',
            more_columns: '他の列',
            tooltip_table: 'テーブル',
            tooltip_indexes: 'インデックス',
            tooltip_enum: 'Enum',
            tooltip_default: 'デフォルト',
            tooltip_generated: '生成',
            tooltip_check: 'チェック',
        },
        m_export_code: {
            title: 'コード {{db_engine}} をエクスポート',
            download_file: 'ファイルをダウンロード',
            copy_code: 'コードをコピー'
        },
        m_sign_in_remind: {
            title: 'DB Design をお試しいただきありがとうございます',
            subtitle: 'サインインまたはサインアップして、テーブル数の上限を引き上げ、ダイアグラムを保存し、さらに多くの機能を利用しましょう。'
        },
        m_sign_in_restrict: {
            title: 'アプリでさらに作業するにはサインイン',
            subtitle: 'サインインまたはサインアップして、テーブル上限を増やし、ダイアグラムを保存し、さらに多くの機能を解放しましょう。'
        },
        m_new_diagram: {
            title: '新規ダイアグラム',
            subtitle: 'データベースエンジンを選択',
            open_diagram: 'ダイアグラムを開く',
            create_diagram: 'ダイアグラムを作成',
            no_workspace: 'ダイアグラムを作成するには、まずワークスペースを作成してください。',
            build_something_new: '新しく何かを作りましょう',
            create_diagram_section: 'ダイアグラムを作成',
            clone_template_btn: 'テンプレートを複製',
        },
        m_diagram_name: {
            enter_new_name: '新しいダイアグラム名を入力',
        },
        m_diagram_clone: {
            header: 'ダイアグラムを複製',
            copy_of_title: '{{title}} のコピー',
        },
        m_diagram_rename: {
            header: 'ダイアグラム名を変更',
        },
        m_template_clone: {
            header: 'テンプレートからダイアグラムを作成',
        },
        m_diagram_delete: {
            header: 'ダイアグラムを削除',
            desc_prefix: '次のダイアグラムを削除します: ',
        },
        m_diagram_archive: {
            header: 'ダイアグラムをアーカイブ',
            desc_prefix: '次のダイアグラムをアーカイブします: ',
        },
        m_diagram_restore: {
            header: 'ダイアグラムを復元',
            desc_prefix: '次のダイアグラムを復元します: ',
        },
        m_diagram_import: {
            sql_name: 'SQL コードをインポート',
            dbml_name: 'DBML コードをインポート',
            placeholder: 'ご意見をお聞かせください！',
        },
        m_diagram_not_found: {
            header: 'ダイアグラムが見つかりません',
            desc: 'お探しのダイアグラムが見つかりませんでした。',
            back_to_app: 'アプリに戻る',
        },
        m_diagram_share: {
            header: 'ダイアグラムを共有 – {{title}}',
            owner_only_invite: 'オーナーのみが新しいメンバーを招待できます',
            invited_to_workspace: 'ワークスペースに招待済み',
            you: 'あなた',
            email_placeholder: 'メールアドレスを入力',
            email_already_in_list: 'このメールアドレスはすでにリストにあります',
            will_be_invited_to_workspace: 'ワークスペースに招待されます',
        },
        m_invite_people: {
            header: 'ワークスペースに招待',
        },
        m_invite_revoke: {
            header: '招待を取り消す',
            desc_prefix: '次の招待を取り消します: ',
            desc_suffix: 'この招待は無効になります。',
        },
        m_member_remove: {
            header: 'メンバーを削除',
            desc_prefix: '次のメンバーを削除しますか: ',
            desc_suffix: 'このワークスペースへのアクセス権を失います。',
        },
        m_template_details: {
            preview: 'プレビュー',
            use_template: 'テンプレートを使用',
        },
        m_workspace_create: {
            header: '新しいワークスペースを作成',
            name_label: '名前',
            setup_config_label: 'セットアップ設定',
            setup_config_value: '空のワークスペース',
            template_structure_label: 'テンプレート / 構成',
            template_structure_value: '構成をプリロード',
            placeholder: 'ワークスペース名を入力',
            create_button: 'ワークスペースを作成',
            creating: 'ワークスペースを作成中...',
        },
        m_workspace_delete: {
            header: 'ワークスペースを削除',
            desc_prefix: '次のワークスペースを完全に削除します: ',
            confirm_prefix: '確認のため ',
            confirm_suffix: ' と入力してください。',
        },
        m_workspace_leave: {
            header: 'ワークスペースを退出',
            desc_prefix: '次のワークスペースから退出します: ',
            desc_suffix: '再度参加するには招待が必要です。',
        },
        m_workspace_menu: {
            manage_members: 'メンバーを管理',
            switch_workspace: 'ワークスペースを切り替え',
            workspaces_label: 'ワークスペース',
            create_workspace: 'ワークスペースを作成...',
            switching: '切り替え中',
        },
        m_profile_menu: {
            profile: 'プロフィール',
            onboarding: 'オンボーディング',
        },
        m_pricing_limit: {
            admin_roles: { title: 'コラボレーションをレベルアップ', description: 'アップグレードして、管理者、編集者、コメンター、ビューアーなどのより多くの共有ロールを利用しましょう。' },
            workspaces: { title: '急成長中ですね！', description: 'アップグレードして、プロジェクトやチーム用のワークスペースをさらに作成・管理しましょう。' },
            workspaces_canvas: { title: 'ワークスペースを拡張', description: 'アップグレードして、プロジェクトやチーム用のワークスペースをさらに作成・管理しましょう。' },
            members: { title: '大規模なコラボレーション', description: 'アップグレードして、ワークスペースにさらに多くのメンバーを迎え、より効果的にコラボレーションしましょう。' },
            diagrams: { title: '急成長中ですね！', description: 'アップグレードして、さらに多くのダイアグラムを作成し、自信を持ってプロジェクトを進めましょう。' },
            tables: { title: '制限なく作成', description: 'アップグレードして、さらに多くのテーブルを追加し、より大規模で詳細なダイアグラムを構築しましょう。' },
            columns: { title: '制限なく作成', description: 'アップグレードして、さらに多くの列を追加し、より大規模で詳細なダイアグラムを構築しましょう。' },
            notes: { title: '制限なく作成', description: 'アップグレードして、さらに多くのメモを追加し、より大規模で詳細なダイアグラムを構築しましょう。' },
            areas: { title: '制限なく作成', description: 'アップグレードして、さらに多くのエリアを追加し、より大規模で詳細なダイアグラムを構築しましょう。' },
            pens: { title: '制限なく作成', description: 'アップグレードして、さらに多くの描画を追加し、より大規模で詳細なダイアグラムを構築しましょう。' },
            default_title: 'コラボレーションをレベルアップ',
            default_title_canvas: 'パフォーマンスをレベルアップ',
        },
        m_pricing_plans: {
            title: 'プランをアップグレード',
            subtitle: 'プランはいつでもアップグレードまたはダウングレードできます',
            monthly: '月額',
            annually: '年額',
            billed_annually: '年払い',
            billed_monthly: '月払い',
            free_for_everyone: '誰でも無料',
            current_plan: '現在のプラン',
            will_be_available_soon: '近日公開予定',
            price_period_user_month: '/ユーザー/月',
            plan_free: {
                name: '無料',
                button: 'プランを変更',
                feature_realtime: 'リアルタイムコラボレーション',
                feature_members: '4 メンバー / ワークスペース',
                feature_diagrams: '4 ダイアグラム / ワークスペース',
                feature_tables: '40 テーブル / ダイアグラム',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: 'すべての無料機能 +',
                feature_members: 'メンバー数無制限',
                feature_diagrams: 'ダイアグラム数無制限',
                feature_tables: 'テーブル数無制限',
                feature_history: 'バージョン履歴',
                feature_admin_roles: '管理者ロール',
            },
        },
        sidebar: {
            new: '新規',
            pinned_diagrams: 'ピン留めしたダイアグラム',
            pin_hint: 'ダイアグラムをピン留めするとここに表示されます',
            expand_sidebar: 'サイドバーを展開',
            home_aria: 'DB Design ホーム',
            open_menu: 'メニューを開く',
            close_menu: 'メニューを閉じる',
            sidebar_menu_aria: 'サイドバーメニュー',
            plan_suffix: 'プラン',
            diagram_options: 'ダイアグラムオプション',
            pin: 'ピン留め',
            unpin: 'ピン留めを解除',
            edit_details: '詳細を編集',
            see_details: '詳細を見る',
            invite_people: '招待',
            collapse_sidebar: 'サイドバーを折りたたむ',
            close_sidebar: 'サイドバーを閉じる',
            open_sidebar: 'サイドバーを開く',
            open_new_tab: '新しいタブで開く',
        },
        focus_controls: {
            show_top: '上部コントロールを表示',
            hide_top: '上部コントロールを非表示',
            show_left: '左側コントロールを表示',
            hide_left: '左側コントロールを非表示',
        },
        m_keyboard_shortcuts: {
            title: 'キーボードショートカット',
            general: {
                title1: '一般',
                title2: '',
                items: {
                    new_diagram: 'ダイアグラムを作成',
                    new_chat: '新しいチャット',
                    search: 'クイックアクション / 検索',
                    preferences: '環境設定',
                    settings: '設定',
                    keyboard_shortcuts: 'キーボードショートカット',
                    toggle_sidebar: 'サイドバーの切り替え',
                    toggle_theme: 'テーマの切り替え',
                },
            },
            ctrl_left: {
                title1: 'コントロール',
                title2: '(左)',
                items: {
                    mouse_sel: 'マウス選択 / ハンドモード',
                    table: 'テーブル',
                    line: 'ライン',
                    area: 'エリア',
                    note: 'メモ',
                    comment: 'コメント',
                    pen: 'ペン',
                    undo: '元に戻す',
                    redo: 'やり直す'
                },
            },
            ctrl_top_left: {
                title1: 'コントロール',
                title2: '(左上)',
                items: {
                    export_img: '画像をエクスポート',
                    search: '検索',
                    editor_panel: 'エディターパネル',
                    zoom_to_fit: '画面に合わせる',
                },
            },
            ctrl_bottom_right: {
                title1: 'コントロール',
                title2: '(右下)',
                items: {
                    minimap: 'ミニマップ',
                    full_screen: '全画面表示',
                    zoom_in: 'ズームイン',
                    zoom_out: 'ズームアウト',
                    zoom_100: 'ズーム 100%'
                },
            },
            ctx_tab: {
                title1: 'コンテキストメニュー',
                title2: '(テーブル)',
                items: {
                    dupl_tab: 'テーブルを複製',
                    del_tab: 'テーブルを削除'
                },
            },
            ctx_del_tab: {
                title1: 'コンテキストメニュー',
                title2: '(テーブルの削除)',
                items: {
                    yes: 'はい',
                    no: 'いいえ'
                },
            },
            ctx_tab_col: {
                title1: 'コンテキストメニュー',
                title2: '(テーブル列)',
                items: {
                    add_col_below: '下に列を追加',
                    focus_col_above: '上の列にフォーカス',
                    focus_col_below: '下の列にフォーカス',
                    move_col_up: '列を上へ移動',
                    move_col_down: '列を下へ移動',
                    dupl_col: '列を複製',
                    del_col: '列を削除'
                },
            },
            ctx_line: {
                title1: 'コンテキストメニュー',
                title2: '(ライン)',
                items: {
                    del_line: 'ラインを削除'
                },
            },
            ctx_area: {
                title1: 'コンテキストメニュー',
                title2: '(エリア)',
                items: {
                    dupl_area: 'エリアを複製',
                    del_area: 'エリアを削除'
                },
            },
            ctx_multi: {
                title1: 'コンテキストメニュー',
                title2: '(複数選択)',
                items: {
                    select_all: 'すべての要素を選択',
                    create_area_for_select_els: '選択要素用のエリアを作成',
                    dupl_select_els: '選択要素を複製',
                    del_select_els: '選択要素を削除'
                },
            },
        },
        t: {
            ctrl_left: {
                mouse_select: 'マウス選択',
                table: 'テーブル',
                line: 'ライン',
                area: 'エリア',
                note: 'メモ',
                comment: 'コメント',
                pen: 'ペン',
                undo: '元に戻す',
                redo: 'やり直す'
            },
            ctrl_top_left: {
                home: 'ホーム',
                name: 'ダイアグラム情報',
                editor: 'エディター',
                search: '検索',
                export: 'エクスポートオプション',
                view_mode: '表示モード',
                zoom_to_fit: '画面に合わせる',
                grid: 'グリッドレイアウト',
                history: '履歴',
                main_menu: 'メインメニュー',
                new_diagram: '新規ダイアグラム',
            },
            ctrl_top_right: {
                feature_req: '機能リクエスト',
                feedback: 'フィードバックを送信',
                sign_in: 'サインイン',
                quick_share: 'クイック共有'
            },
            ctrl_bottom_right: {
                full_screen: '全画面表示',
                minimap: 'ミニマップ',
                zoom_out: 'ズームアウト',
                zoom_100: 'ズーム 100%',
                zoom_in: 'ズームイン',
                info: '情報とリソース'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'デフォルト',
                        blue: '青',
                        green: '緑',
                        red: '赤',
                        purple: 'パープル',
                        violet: 'バイオレット'
                    },
                    borders: {
                        none: 'なし',
                        solid: '実線',
                        dashed: '破線',
                        dotted: '点線'
                    },
                    color: '色',
                    border: '枠線',
                    description: '説明',
                    description_table_place: 'テーブルの説明',
                    description_column_place: '列の説明',
                    description_line_place: 'ラインの説明',
                    description_note_place: 'メモの説明',
                    description_area_place: 'エリアの説明',
                    description_pen_place: 'ペンの説明',
                    hide_menu: 'メニューを非表示',
                    show_menu: 'メニューを表示'
                },
                tab_col: {
                    add_col_below: '下に列を追加',
                    add_col_above: '上に列を追加',
                    key: 'Key',
                    keys: {
                        none: 'なし',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'なし',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: '列を下へ移動',
                    move_col_up: '列を上へ移動',
                    more_functions: 'その他の機能'
                },
                line: {
                    change_connects: 'コネクタを変更',
                    connects: {
                        empty: '空',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: '要素をフィルタ'
                },
                note: {
                    link_placeholder: 'リンクを入力',
                    link_apply: '追加',
                    link_remove: '削除',
                    link_edit: '編集',
                    link_needs_selection: 'テキストを選択してリンクを追加',
                    bulleted_list: 'リスト',
                    numbered_list: '番号付きリスト',
                    font_style: 'フォントスタイル',
                    alignment: '配置',
                    align_left: '左揃え',
                    align_center: '中央揃え',
                    align_right: '右揃え',
                    link: 'リンク',
                    monospace: '等幅',
                    bold: '太字',
                    italic: '斜体',
                    underline: '下線',
                    strikethrough: '取り消し線',
                },
                multi: {
                    filter: '選択をフィルタ',
                    create_area: 'エリアを作成'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'すべて',
            keys_only: 'キーのみ',
            names_only: '名前のみ'
        },
        dropdown_ctrl_grid: {
            none: 'なし',
            lines: 'ライン',
            dots: 'ドット',
        },
        dropdown_ctrl_export: {
            export_img: '画像をエクスポート',
            export_code: 'SQL コードをエクスポート'
        },
        dropdown_ctrl_settings: {
            back_home: 'ホームに戻る',
            sign_in: 'サインイン',
            preferences: '環境設定',
            new_project: '新規プロジェクト',
            import_diagram: 'ダイアグラムをインポート',
            duplicate_diagram: 'ダイアグラムを複製',
            keyboard_shortcuts: 'キーボードショートカット',
            languages: '言語',
            view: '表示',
            upgrade_plan: 'プランをアップグレード',
            language: '言語',
            mouse_trackpad: 'マウスまたはトラックパッド',
            background_color: '背景色',
            grid_layout: 'グリッドレイアウト',
            view_mode: '表示モード',
            show_align_lines: '整列ラインを表示',
            show_members_cursors: 'メンバーのカーソルを表示',
            show_comments: 'コメントを表示',
            undo_redo_controls: '元に戻す/やり直すコントロール',
            show_scrollbars: 'スクロールバーを表示',
            opt_auto: '自動',
            opt_trackpad: 'トラックパッド',
            opt_mouse: 'マウス',
            opt_default: 'ダーク（デフォルト）',
            opt_gray: 'グレー',
            opt_blue: 'ブルー',
            opt_purple: 'パープル',
            opt_violet: 'バイオレット',
            opt_green: 'グリーン',
            opt_red: 'レッド',
            opt_yellow: 'イエロー',
            opt_dots: 'ドット',
            opt_lines: 'ライン',
            opt_none: 'なし',
            opt_full: 'フル',
            opt_keys: 'キー',
            opt_names: '名前',
        },
        dropdown_ctrl_info_resources: {
            feedback: 'フィードバック',
            keyboard_shortcuts: 'キーボードショートカット',
            languages: '言語',
            homepage: 'ホームページ'
        },
        n: {
            default: '読み込み中…',
            file_ready_to_download: 'ファイルのダウンロード準備ができました',
            code_copied: 'コードをコピーしました',
            link_copied: 'リンクをコピーしました',
            username_copied: 'ユーザー名をコピーしました',
            email_copied: 'メールアドレスをコピーしました',
            please_enter_message: 'メッセージを入力してください',
            invalid_email: 'メールアドレスが無効です',
            note_link_unsupported_protocol: 'このリンクの形式には対応していません。https、http、mailto を使用してください。',
            something_wrong_contact: '問題が発生しました。ページを再読み込みするか、サポートへご連絡ください。',
            something_wrong: '問題が発生しました。ページを再読み込みしてください。',
            sending: '送信中…',
            request_sent: 'リクエストを送信しました。ありがとうございます!',

            please_enter_email: 'メールアドレスを入力してください',
            changing: '変更中...',
            role_changed: 'ロールを変更しました',
            removing: '削除中...',
            member_removed: 'メンバーを削除しました',
            inviting: '招待中...',
            invite_sent: '招待を送信しました',
            added_to_diagram: 'ダイアグラムに追加しました',
            invite_removed: '招待を削除しました',
            role_not_allowed_on_plan: 'このロールは現在のプランでは利用できません。アップグレードして割り当てましょう。',
            already_diagram_member: 'この人はすでにダイアグラムにアクセスできます。',
            cannot_invite_to_workspace: 'ワークスペース管理者に、この人をワークスペースへ招待するよう依頼してください。',
            saving: '保存中...',
            saved: '保存しました',
            diagram_renamed: 'ダイアグラム名を変更しました',
            diagram_updated: 'ダイアグラムを更新しました',
            duplicating: '複製中...',
            diagram_duplicated: 'ダイアグラムを複製しました',
            deleting: '削除中...',
            diagram_archived: 'ダイアグラムをアーカイブしました',
            diagram_deleted: 'ダイアグラムを削除しました',
            restoring: '復元中...',
            diagram_restored: 'ダイアグラムを復元しました',
            diagram_pinned: 'ダイアグラムをピン留めしました',
            diagram_unpinned: 'ダイアグラムのピン留めを解除しました',
            creating: '作成中...',
            diagram_created: 'ダイアグラムを作成しました',
            forbidden: 'アクセス権がありません。',
            invite_already_pending: 'この人にはすでに招待が保留中です。',
            already_member: 'すでにワークスペースのメンバーです',
            cannot_invite_self: '自分自身を招待することはできません',
            workspace_not_found: 'ワークスペースが見つかりません。ページを更新してもう一度お試しください。',
            diagram_not_found: 'ダイアグラムが見つかりません。',
            has_diagram_members: 'ダイアグラムにアクティブなメンバーがいます',
            seat_limit_reached: 'プランの席数上限に達しました。アップグレードしてさらに招待しましょう。',
            feature_not_in_plan: 'この機能は現在のプランに含まれていません。',
            subscription_expired: 'サブスクリプションの期限が切れています。継続するには更新してください。',
            subscription_inactive: 'サブスクリプションが無効です。お支払い情報を更新してください。',
            plan_limit_generic: '現在のプランではこの操作を行えません。アップグレードして続行してください。',

            // Auth / profile
            session_expired: 'セッションの有効期限が切れました — もう一度サインインしてください。',
            profile_updated: 'プロフィールを更新しました',
            profile_update_failed: 'プロフィールの更新に失敗しました。',
            account_delete_failed: 'アカウントの削除に失敗しました。',

            // Preferences
            couldnt_save: '変更を保存できませんでした',
            try_again: '問題が発生しました。もう一度お試しください。',

            // Workspace
            not_workspace_member: 'このワークスペースのメンバーではありません。',
            workspace_switch_failed: 'ワークスペースを切り替えられませんでした。もう一度お試しください。',
            workspace_create_failed: 'ワークスペースを作成できませんでした。もう一度お試しください。',
            invalid_workspace_name: '無効なワークスペース名です',
            workspace_updated: 'ワークスペースを更新しました',
            workspace_update_failed: 'ワークスペースを更新できませんでした。もう一度お試しください。',
            last_owner_cannot_leave: 'あなたが唯一のオーナーです。他のメンバーをオーナーにするか、ワークスペースを削除してから退出してください。',
            workspace_leave_failed: 'ワークスペースを退出できませんでした。もう一度お試しください。',
            workspace_delete_forbidden: 'ワークスペースを削除できるのはオーナーのみです。',
            workspace_has_active_billing: 'このワークスペースを削除する前に、サブスクリプションを解約してください。',
            workspace_deleted: 'ワークスペースを削除しました',
            workspace_delete_failed: 'ワークスペースを削除できませんでした。もう一度お試しください。',
            member_remove_forbidden: 'このメンバーを削除する権限がありません。',
            member_remove_failed: 'メンバーを削除できませんでした。もう一度お試しください。',
            cannot_remove_self: '自分自身を削除するには「ワークスペースを退出」を使用してください。',
            cannot_remove_last_owner: 'ワークスペースには必ずオーナーが必要です。先に他のメンバーをオーナーにしてください。',
            invite_revoke_forbidden: 'この招待を取り消す権限がありません。',
            invite_revoke_failed: '招待を取り消せませんでした。もう一度お試しください。',
        },
        dashboard: {
            doc_title: 'ダイアグラム',
            filter_all: 'すべて',
            filter_mydiagrams: 'マイダイアグラム',
            filter_shared: '共有されたダイアグラム',
            filter_archived: 'アーカイブ済み',
            empty_all: '「すべてのダイアグラム」にダイアグラムがありません',
            empty_mydiagrams: '「マイダイアグラム」にダイアグラムがありません',
            empty_shared: '「共有されたダイアグラム」にダイアグラムがありません',
            empty_archived: '「アーカイブ済み」にダイアグラムがありません',
            example_diagram_badge: 'サンプルダイアグラム',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: 'アプリに戻る',
                group_personal: '個人',
                group_organization: '組織',
                billing: '請求',
            },
            profile: {
                member_since: '{{date}}からのメンバー',
                general: '一般',
                email: 'メール',
                full_name: '氏名',
                full_name_placeholder: '名前を入力',
                account_protection: 'アカウント保護',
                mfa_label: '多要素認証 (MFA)',
                mfa_sub: 'アカウントに追加のセキュリティ層を設定 · 近日公開',
                mfa_enable: 'MFAを有効にする',
                mfa_soon_tooltip: '近日公開予定',
                workspace_access: 'ワークスペースへのアクセス',
                leave_workspace: 'ワークスペースを退出',
                leave_workspace_sub: 'ワークスペースから自分を削除します',
                leave_owner_tooltip: '退出する前にオーナー権限を譲渡してください',
            },
            workspace: {
                header: 'ワークスペース',
                general: '一般',
                name_label: 'ワークスペース名',
                name_placeholder: 'ワークスペース名',
                stat_member_singular: 'メンバー',
                stat_member_plural: 'メンバー',
                stat_team_singular: 'チーム',
                stat_team_plural: 'チーム',
                members_section: 'メンバー',
                no_members: 'メンバーがいません',
                count_member_singular: 'メンバー',
                count_member_plural: 'メンバー',
                view_members_btn: 'メンバーを表示',
                danger_zone: '危険な操作',
                delete_workspace: 'ワークスペースを削除',
                delete_workspace_sub: 'ワークスペースが完全に削除されます',
                delete_owner_only_tooltip: 'ワークスペースを削除できるのはオーナーのみです',
                delete_cancel_sub_tooltip: 'ワークスペースを削除する前にサブスクリプションを解約してください',
            },
            members: {
                header: 'メンバー',
                col_name: '名前',
                col_email: 'メール',
                col_role: '役割',
                col_joined: '参加日',
                active_members: 'アクティブなメンバー',
                invited_section: '招待済み',
                no_members: 'まだメンバーがいません。',
                options_aria: 'オプション',
                leave_workspace_item: 'ワークスペースを退出...',
                remove_member_item: 'メンバーを削除...',
                remove_owner_only_tooltip: 'メンバーを削除できるのはオーナーのみです',
                remove_owner_row_tooltip: 'オーナーはワークスペースから削除できません',
                remove_invite_item: '招待を削除...',
                role_invited_suffix: '{{role}}（招待済み）',
            },
            preferences: {
                section_general: '一般',
                section_diagram_defaults: 'ダイアグラムの設定',
                section_diagram_views: 'ダイアグラム表示',
                section_notifications: '通知',
                theme_label: 'インターフェースのテーマ',
                theme_sub: 'インターフェースの配色を選択',
                theme_dark: 'ダーク',
                theme_light: 'ライト',
                theme_system: 'システム',
                language_sub: 'インターフェースの言語を選択',
                timezone_label: 'タイムゾーン',
                timezone_sub: 'タイムゾーンを選択',
                timezone_options: {
                    honolulu: 'GMT-10:00 — ハワイ',
                    anchorage: 'GMT-09:00 — アラスカ',
                    los_angeles: 'GMT-08:00 — 太平洋時間',
                    denver: 'GMT-07:00 — 山岳部標準時',
                    chicago: 'GMT-06:00 — 中部標準時',
                    new_york: 'GMT-05:00 — 東部標準時',
                    caracas: 'GMT-04:00 — カラカス',
                    sao_paulo: 'GMT-03:00 — サンパウロ',
                    azores: 'GMT-01:00 — アゾレス諸島',
                    london: 'GMT+00:00 — ロンドン',
                    paris: 'GMT+01:00 — パリ、ベルリン',
                    kyiv: 'GMT+02:00 — キーウ、アテネ',
                    istanbul: 'GMT+03:00 — イスタンブール',
                    dubai: 'GMT+04:00 — ドバイ',
                    karachi: 'GMT+05:00 — カラチ',
                    kolkata: 'GMT+05:30 — インド',
                    dhaka: 'GMT+06:00 — ダッカ',
                    bangkok: 'GMT+07:00 — バンコク、ジャカルタ',
                    shanghai: 'GMT+08:00 — 北京、シンガポール',
                    tokyo: 'GMT+09:00 — 東京、ソウル',
                    sydney: 'GMT+10:00 — シドニー',
                    auckland: 'GMT+12:00 — オークランド',
                },
                input_mode_sub: 'キャンバスの操作方法を選択',
                background_sub: 'キャンバスの背景色を選択',
                grid_sub: 'キャンバスのグリッドレイアウトを選択',
                show_align_lines_sub: 'オブジェクトの整列時に線を表示',
                show_cursors_sub: '他のメンバーのカーソルを表示',
                show_comments_sub: 'キャンバス上にコメントを表示',
                show_scrollbars_sub: 'キャンバス操作中にスクロールバーを表示',
                show_undo_redo_label: '元に戻す/やり直しコントロールを表示',
                show_undo_redo_sub: '変更を元に戻す・やり直すためのコントロールを表示',
                notif_shared_label: '自分と共有されたダイアグラム',
                notif_shared_sub: '誰かがダイアグラムを自分と共有したとき',
                notif_mentions_label: 'コメント内のメンション',
                notif_mentions_sub: '誰かがコメントで自分に@メンションしたとき',
                notif_updates_label: '製品アップデート',
                notif_updates_sub: '新機能や改善点に関する月次アップデート',
                show: '表示',
                hide: '非表示',
                on: 'オン',
                off: 'オフ',
            },
            billing: {
                header: '請求',
                plan_free: '無料プラン',
                status_current: '現在',
                no_renewal_needed: '更新の必要はありません',
                payment_header: '支払い',
                no_payments: '支払いはありません',
                invoices_header: '請求書',
                no_invoices: '請求書はありません',
            },
            usage: {
                doc_title: '使用状況',
                overview_title: '概要',
                resource_limits_title: 'リソース上限',
                label_diagrams: 'ダイアグラム',
                label_tables: 'テーブル',
                label_areas: 'エリア',
                label_notes: '付箋',
                label_members: 'メンバー',
                label_tables_per_diagram: 'テーブル数 / ダイアグラム',
                label_areas_per_diagram: 'エリア数 / ダイアグラム',
                label_notes_per_diagram: '付箋数 / ダイアグラム',
                need_more_title: 'もっと必要ですか？',
                need_more_free: 'より多くのダイアグラム、バージョン履歴、優先サポートには Basic へのアップグレードをご検討ください。',
                need_more_paid: '無制限のダイアグラム、シート、高度な機能には Professional へのアップグレードをご検討ください。',
            },
        },
        pages: {
            not_found: {
                page_not_found: 'ページが見つかりません',
                dont_have_access_to_diagram: 'このダイアグラムへのアクセス権がないか、すでに存在しません。',
                back_home: 'ホームに戻る'
            },
            error: {
                title: 'エラー',
                link_is_invalid: 'このリンクは無効か、入力内容に誤りがあります。',
                something_wrong: '問題が発生しました。',
                back_home: 'ホームに戻る',
                please_try_later: '後ほどもう一度お試しください',
            },
            billing_success: {
                doc_title: 'プランがアップグレードされました',
                heading: '支払いが完了しました',
                subtitle: 'プランが正常にアップグレードされました。',
                cta: 'デザインを始める',
            },
            email_verified: {
                doc_title: 'メール確認済み',
            },
            forgot_password: {
                doc_title: 'パスワードをお忘れですか',
            },
            password_updated: {
                doc_title: 'パスワードを更新しました',
            },
            reset_password: {
                doc_title: 'パスワードを再設定',
            },
            check_email: {
                doc_title: 'メールをご確認ください',
            },
            sign_in: {
                doc_title: '{{product}} にサインイン',
            },
            sign_up: {
                doc_title: '{{product}} にサインアップ',
            },
        },
    },
};

export const jaMeta = {
    lang_origin: '日本語',
    lang_eng: 'Japanese',
    lang_code: 'ja',
};
